module.exports = __webpack_public_path__ + "static/PenumbraFlareStd-Bold_gdi-717c1c71f98d6e3da6287eb57e3d69d8.woff";